import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { VoucherButton } from '@entities/voucher';
import { withTheme } from '@shared/lib';
import { Payee } from '@root/api/ump-catalog-manager';
import { useCyberStore } from '@entities/tsp';
interface Props {
  activeService: Payee;
  denominationsByCountry: Record<string, Payee[]>;
}
const VoucherList: FC<Props> = ({
  denominationsByCountry,
  activeService
}) => {
  const {
    activeCountry,
    activeDenomination,
    setActiveDenomination
  } = useCyberStore();
  const handleDenominationClick = (denomination: Payee) => {
    setActiveDenomination(denomination);
  };
  return <VoucherWrapper>
      <VouchersWrapper>
        {denominationsByCountry?.[activeCountry as string]?.map(denominationInfo => denominationInfo?.features?.buttonLabel && <VoucherButton key={denominationInfo.serviceId} activeDenomination={activeDenomination as Payee} handleDenominationClick={handleDenominationClick} denominationInfo={denominationInfo} activeService={activeService} />)}
      </VouchersWrapper>
    </VoucherWrapper>;
};
export default VoucherList;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.md;
const VoucherWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "VoucherWrapper",
  class: "vh987fc",
  propsAsIs: false,
  vars: {
    "vh987fc-0": [_exp()],
    "vh987fc-1": [_exp2(), "px"],
    "vh987fc-2": [_exp3()],
    "vh987fc-3": [_exp4(), "px"],
    "vh987fc-4": [_exp5(), "px"]
  }
}));
const VouchersWrapper = /*#__PURE__*/styled('div')({
  name: "VouchersWrapper",
  class: "v1ws2tl3",
  propsAsIs: false
});

require("./VoucherList.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./VoucherList.tsx");